module.exports = __webpack_public_path__ + "media/images/bg-concentrated-right-01909a71802aabaf2f8c491fa0a017b8.svg";